import { render, staticRenderFns } from "./wdpjSet.vue?vue&type=template&id=dfd20bc2&scoped=true&"
import script from "./wdpjSet.vue?vue&type=script&lang=js&"
export * from "./wdpjSet.vue?vue&type=script&lang=js&"
import style0 from "./wdpjSet.vue?vue&type=style&index=0&id=dfd20bc2&prod&lang=scss&scoped=true&"
import style1 from "./wdpjSet.vue?vue&type=style&index=1&id=dfd20bc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd20bc2",
  null
  
)

export default component.exports